import React from 'react';
import NavBar from '../navBar/NavBar';
import HelpModal from '../modals/HelpModal';
import InfoModal from '../modals/InfoModal';
import { useModal } from '../../context/ModalContext';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { activeModal, openModal, closeModal } = useModal();

  return (
    <div className="App">
      <NavBar
        infoButtonOnClick={() => openModal('info')}
        helpButtonOnClick={() => openModal('help')}
      />

      {/* Page content */}
      <div className="page-body">{children}</div>

      {/* Shared Modals */}
      <HelpModal isOpen={activeModal === 'help'} onClose={closeModal} />
      <InfoModal isOpen={activeModal === 'info'} onClose={closeModal} />
      <footer className="page-footer padding" />
    </div>
  );
}
